export default "/assets/2ab1beff9be20b2f.svg"